import { DeployPurchase, InfoPurchase } from './../../core/interfaces/purchase.model';
import { AuthService } from 'src/app/core/auth/auth.service';
import { environment } from './../../../environments/environment';
import { Component, OnInit, AfterViewInit, OnDestroy, Inject, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MoviesService, Tag_Type } from '../../core/services/movies.service';
import { CountryModel, MovieModel, PersonModel, PictureModel } from 'src/app/core/interfaces/movie.model';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import Swal from 'sweetalert2';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { ParametersService } from 'src/app/core/services/parameters.service';
import { ParameterModel } from 'src/app/core/interfaces/parameter.model';

import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Console } from 'console';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-movie',
  templateUrl: './movie.component.html',
  styleUrls: ['./movie.component.css'],
})
export class MovieComponent implements OnInit, OnDestroy, AfterViewInit {
  isBrowser: boolean;

  mySwiper: SwiperConfigInterface = {
    init: true,
    speed: 1000,
    autoplay: { delay: 3000 },
    effect: 'fade',
    initialSlide: 3,
  };
  PARAMS: ParameterModel;

  fadeOut = false;
  fadeOutTime = 3;//segundos

  constructor(
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private router: Router,
    private auth: AuthService,
    private movieService: MoviesService,
    public san: DomSanitizer,
    private parametersService: ParametersService,
    private metaService: Meta,
    @Inject(PLATFORM_ID) platformId
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  movie: MovieModel;
  idMovie: number;

  modalLogin: any;
  modalRegister: any;
  modalTrailer: any;
  modalPayment: any;

  objetoPurchase: DeployPurchase;
  infoCompra: InfoPurchase;

  reproducirTrailer = false;
  mostrarTarjetas = false;
  mostrarPanelProduccion = false;
  tipoTrailer: 'vimeo' | 'youtube';
  esEstreno = false;
  esCinema = false;
  isFree = false;

  countries: CountryModel[];
  picturesNoPoster: PictureModel[];

  tabSelected: number = 1;

  scrollInterval: any;

  ipValid: any = true;
  tccLinkExists = false;
  movieScore: number = 0;
  sharedUrl = "";
  sharedText = "";
  sharedUrls = {
    facebook: "",
    twitter: "",
    whatsapp: "",
    whatsappMobile: ""
  }


  async ngAfterViewInit() {
    if (this.isBrowser) {
      this.modalLogin = $('#modalLogin');
      this.modalRegister = $('#modalRegister');
      this.modalTrailer = $('#modalTrailer');
      this.modalPayment = $('#modalPayment');


      // Al abrir modal de trailer, se crea el content del modal para que pueda reproducir
      $(document).on('shown.bs.modal', '#modalTrailer', (e) => (this.reproducirTrailer = true));

      // Al cerrar modal de trailer, se destruye el content del modal para que no siga reproduciendo
      $(document).on('hidden.bs.modal', '#modalTrailer', (e) => (this.reproducirTrailer = false));

      // Al abrir modal de tarjetas, se actualizan los medios de pago
      $(document).on('shown.bs.modal', '#modalPayment', (e) => (this.mostrarTarjetas = true));
      $(document).on('hidden.bs.modal', '#modalPayment', (e) => (this.mostrarTarjetas = false));
    }
  }

  async ngOnInit() {

    if (this.isBrowser) window.scrollTo(0, 0);

    this.idMovie = parseInt(this.activatedRoute.snapshot.params.id);

    // Cargar parámetros
    this.PARAMS = await this.parametersService.getAllParameters();

    // Cargar datos de la movie
    this.movieService.getMovieById(this.idMovie).subscribe(
      (resp: MovieModel) => {
        this.movie = resp;
        this.countries = this.movie.countries;
        this.movie.movieLink = resp.movieLink;

        // cocardas: free -> estreno -> en sala
        if (this.movie.paymentOption == 0) {
          this.isFree = true;
        }

        if (!this.isFree) {
          this.esEstreno = this.movie.categories.find((c) => {
            return c.id === parseInt(this.PARAMS.ESTRENOS_ID.value);
          }) ? true : false;

          if (!this.esEstreno) {
            this.esCinema = this.movie.categories.find((m) => {
              return m.id === parseInt(this.PARAMS.CINEMA_ID.value);
            }) ? true : false;
          }
        }

        // Ajuste nombre director
        if (resp.directors.length > 0) {
          var dires = '';
          resp.directors.forEach((element) => {
            dires = dires + element.name + ' ' + element.lastName + ', ';
          });
          dires = dires.substr(0, dires.length - 2);
          this.movie.directorFullName = dires; // resp.directors[0].name + ' ' + resp.directors[0].lastName;
        }

        // Ajustar descripcion
        if (resp.description) {
          resp.description = resp.description.replace(/\n/g, '<br>');
        }

        // Ajuste url fotos
        if (resp.pictures.length > 0) {
          console.log(this.movie.pictures);

          this.movie.pictures = resp.pictures.map((pic) => {
            return {
              ...pic,
              pictureLinkFull: environment.apiEndpoint + pic.pictureLink,
            };
          });
        }

        // Ajuste url frames
        if (resp.frames.length > 0) {
          this.movie.frames = resp.frames.map((fr) => {
            return {
              ...fr,
              pictureLinkFull: environment.apiEndpoint + fr.pictureLink,
            };
          });
          console.log(this.movie.frames);
        }

        this.movie.picturesNoPoster = [];
        this.movie.pictures.forEach(p => {
          if (!p.isPoster) {
            this.movie.picturesNoPoster.push(p);
          }
        });

        //ajusto fecha de estreno
        if (resp.premierDateUY) {
          this.movie.premierDateUYformated = moment(this.movie.premierDateUY).format('DD/MM/YYYY');
        }

        // Ajuste url trailer
        if (resp.trailerLink) {
          // YOUTUBE
          if (resp.trailerLink.includes('youtube')) {
            this.tipoTrailer = 'youtube';

            let idVideo = resp.trailerLink.split('v=')[1];
            this.movie.trailerLinkIframe = `https://www.youtube.com/embed/${idVideo}?rel=0`;
          }

          // VIMEO
          if (resp.trailerLink.includes('vimeo')) {
            this.tipoTrailer = 'vimeo';

            let idVideo = resp.trailerLink.split('/')[3];
            this.movie.trailerLinkIframe = `https://player.vimeo.com/video/${idVideo}?autoplay=1&title=0&byline=0&portrait=0&controls=1`;
          }
        }

        // Creación de urls para compartir en RRSS

        let urlSharedMovie = `${environment.hostName}/movie/${resp.id}`;
        let urlSharedText = `+Cinemateca - ${resp.title} `;

        this.sharedUrls.facebook = `https://www.facebook.com/sharer/sharer.php?u=${urlSharedMovie}&quote=${urlSharedText}`;
        this.sharedUrls.twitter = `https://twitter.com/intent/tweet?url=${urlSharedMovie}&text=${urlSharedText}`;
        this.sharedUrls.whatsapp = `https://web.whatsapp.com/send?text=${urlSharedText} - ${urlSharedMovie}`;
        this.sharedUrls.whatsappMobile = `whatsapp://send?text=${urlSharedText} - ${urlSharedMovie}`;

        this.sharedUrl = urlSharedMovie;
        this.sharedText = urlSharedText;

        if (this.auth.estaAutenticado()) {
          this.movieService.getMoviePrice(this.idMovie || this.movie.id).subscribe((resp: any) => {
            this.movie.payment = resp;
          });
        }

        this.objetoPurchase = {
          type: 'movie',
          movieId: this.idMovie,
        };
        this.cargarMetaTags(this.movie);

        this.loadAndCalculateScore()//SCORE

        this.mostrarPanelProduccion = this.showProductionPanel();

      },
      (error) => {
        if (error.status == 404) {
          Swal.fire('Ups!', 'La película no está disponible', 'error').then(() => { this.router.navigateByUrl('/home') });
        }
        if (error.status == 401) {
          Swal.fire('Ups!', 'No tiene acceso a este contenido', 'error').then(() => { this.router.navigateByUrl('/home') });
        }
        else
          Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error').then(() => { this.router.navigateByUrl('/home') });
      },
    );

    this.ipValid = await this.auth.ipValid(this.idMovie);
    this.tccLinkExists = await this.movieService.getMovieLinkInfoTCCExists(this.idMovie);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.

    if (this.modalLogin) this.modalLogin.modal('hide');
    if (this.modalRegister) this.modalRegister.modal('hide');
    if (this.modalTrailer) this.modalTrailer.modal('hide');
    if (this.modalPayment) this.modalPayment.modal('hide');
  }

  // METODO Auth
  onLogin(respuesta) {
    if (respuesta) {
      this.modalLogin.modal('hide');
    }
  }

  onRegister(respuesta) {
    if (respuesta) this.modalRegister.modal('hide');
  }

  playFadeOut() {
    return new Promise(resolve => {
      this.fadeOut = true;
      setTimeout(resolve, this.fadeOutTime * 1000);
    })
  }

  async watchMovie() {
    if (this.auth.estaAutenticado()) {
      // GRATIS
      console.log(this.movie);

      if (!this.movie.payment) {
        this.movieService.getMoviePrice(this.idMovie || this.movie.id).subscribe((resp: any) => {
          this.movie.payment = resp;
          this.watchOrPay();
        });
      }
      else {
        this.watchOrPay();
      }

    } else {
      this.abrirModal(this.modalLogin);
    }
  }

  async watchOrPay() {
    if (this.movie.paymentOption == 0 || this.movie.payment.price == 0) {
      await this.playFadeOut();
      this.router.navigate(['/watch', this.movie.id]);
    }

    else {
      this.movieService.getMovieIsAvailable(this.movie.id).subscribe(
        (res) => {
          this.playFadeOut().then(() => {
            this.router.navigate(['/watch', this.movie.id]);
          });
        },
        (error) => {
          if (error.status === 402) {
            Swal.fire({
              title: 'Realizar pago',
              text: 'Para ver esta película debe hacer un pago de $' + this.movie.payment.price + "\n Tambien puede usar un cupon.",
              icon: 'warning',
              showCancelButton: true,
              cancelButtonText: 'CANCELAR',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: '<strong>CONTINUAR</strong>',
            }).then(async (result) => {
              if (result.isConfirmed) {
                this.infoCompra = {
                  type: 'movie',
                  title: this.movie.title,
                  description: `Pagar $ ${this.movie.payment.price} por la película ${this.movie.title}.`,
                  price: this.movie.payment.price,
                  movieId: this.movie.id
                };
                this.abrirModal(this.modalPayment);
              }
            });
          }
        },
      );
    }
  }

  watchTrailer() {
    this.modalTrailer = $('#modalTrailer');
    this.modalTrailer.modal('show');
  }

  /**
   * Abre modal declarado, se pasa por parámetro el identificador del DOM o el objeto modal
   * @param modal String || Object
   */
  abrirModal(modal: any) {
    this.modalLogin.modal('hide');
    this.modalRegister.modal('hide');
    this.modalTrailer.modal('hide');
    this.modalPayment.modal('hide');

    if (modal) {
      if (typeof modal === 'string') this[modal].modal('show');
      if (typeof modal === 'object') modal.modal('show');
    }
  }

  loadAndCalculateScore() {
    if (this.movie.totalRatings > 0) {
      this.movieScore = parseFloat((this.movie.ratingScore / this.movie.totalRatings).toFixed(1));//Para mostrar una sola cifra despues de la coma
    }
    else {
      this.movieScore = 0;
    }
  }

  onOpenScores() {
    this.loadAndCalculateScore();//Luego abrir el modal que muestra los scores.
  }

  onRegresar() {
    this.location.back();
  }

  cargarMetaTags(movie: MovieModel) {

    this.metaService.updateTag({ property: "og:description", content: movie.synopsis });

    this.metaService.updateTag({ property: 'og:title', content: movie.title });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });

    this.metaService.updateTag({
      property: 'og:image', itemprop: 'image',
      content: environment.apiEndpoint + movie.pictures.find((p) => p.isDefault).pictureLink,
    });
  }

  clickedInfo() {
    this.tabSelected = 1;
    //iba a hacer autoscroll pero no lo tengo andando bien todavia. Lo dejo pa cuando sobre tiempo.
  }

  clickedComments() {
    this.tabSelected = 2;
    //iba a hacer autoscroll pero no lo tengo andando bien todavia. Lo dejo pa cuando sobre tiempo.
  }

  clickedFrames() {
    this.tabSelected = 3;
    //iba a hacer autoscroll pero no lo tengo andando bien todavia. Lo dejo pa cuando sobre tiempo.
  }

  //no esta bien todavia.
  autoScrollDown() {
    const totalHeight = (25 * document.documentElement.scrollHeight) / 100
    if (window.scrollY < totalHeight) {
      console.log(totalHeight);
      const scrollStep = totalHeight / 20;
      this.scrollInterval = setInterval(() => {
        if (window.scrollY < totalHeight) {
          window.scrollBy(0, scrollStep);
        } else {
          clearInterval(this.scrollInterval);
        }
      }, 15);
    }
  }

  showProductionPanel(): boolean {
    let ret: boolean = false;
    const production: PersonModel[] = this.movie.production;
    const script: PersonModel[] = this.movie.script;
    const photography: PersonModel[] = this.movie.photography;
    const sound: PersonModel[] = this.movie.sound;
    const music: PersonModel[] = this.movie.music;
    const edition: PersonModel[] = this.movie.edition;
    const direction: PersonModel[] = this.movie.directors;
    const cast: PersonModel[] = this.movie.cast;
    ret = this.checkArraysNotEmpty([production, script, photography, sound, music, edition, direction, cast])
    return ret;
  }

  private checkArraysNotEmpty(arrays: any[][]): boolean {
    for (const arr of arrays) {
      if (arr.length > 0) {
        return true;
      }
    }
    return false;
  }

  public get tag_type(): typeof Tag_Type {
    return Tag_Type;
  }

}
